export default "__VITE_ASSET__DJNHEAZf__"